import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { Button } from './Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-4">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.9,
      opacity: 0
    }} transition={{
      type: 'spring',
      duration: 0.3
    }} className="bg-[#0A0A2E] border-2 border-[#00D4FF]/40 rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden shadow-[0_0_50px_rgba(0,212,255,0.3)]" onClick={e => e.stopPropagation()} data-id="element-5">
        <div className="flex items-center justify-between p-6 border-b border-[#00D4FF]/20" data-id="element-6">
          <h2 className="text-2xl font-bold text-white" data-id="element-7">{title}</h2>
          <button onClick={onClose} className="text-[#8892A4] hover:text-white transition-colors p-2 hover:bg-white/5 rounded-lg" data-id="element-8">
            <X className="w-6 h-6" data-id="element-9" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(80vh-120px)]" data-id="element-10">
          {children}
        </div>

        <div className="p-6 border-t border-[#00D4FF]/20 flex justify-end" data-id="element-11">
          <Button variant="primary" size="md" onClick={onClose} data-id="element-12">
            Cerrar
          </Button>
        </div>
      </motion.div>
    </motion.div>;
}